module.exports = __webpack_public_path__ + "static/media/arrows-h.1be7e14b.svg";